import { Link } from "react-router-dom";
import { styled } from "styled-components";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  width: 100%;
  gap: 24px;
  padding: 40px 20px;
  background: ${({ theme }) => theme.colors.white};
`;

const Title = styled.h1`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 48px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
`;

const Message = styled.p`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  margin: 0;
`;

const HomeLink = styled(Link)`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.primary};
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`;

const NotFound = () => {
  return (
    <PageContainer>
      <Title>404</Title>
      <Message>Stránka nenalezena</Message>
      <HomeLink to="/">Zpět na hlavní stránku</HomeLink>
    </PageContainer>
  );
};

export default NotFound;
